/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

import { useContext, useMemo } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';
import corpulsTheme from '../Theme/CorpulsTheme';
import style from './App.scss?inline';
import globalStyle from '../global.scss?inline';
import DiviNavigation from './DiviNavigation/DiviNavigation';
import HeaderBar from './HeaderBar/HeaderBar';
import { PageRouter } from './Pages/PageRouter';
import { CSSContext, useCSS } from '../provider/CSSProvider';
import _ from 'lodash';
import SideBar from './SideBar/SideBar';

function App() {
  useCSS(style);
  useCSS(globalStyle);

  const { additionalThemeComponents } = useContext(CSSContext);

  const theme = useMemo(
    () => createTheme({ ...corpulsTheme, components: _.merge(corpulsTheme.components!, additionalThemeComponents) }),
    [additionalThemeComponents]
  );

  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <div className='wireframe-container'>
          <div className='header'>
            <HeaderBar />
          </div>
          <div className='body-content'>
            <div className='navigation'>
              <DiviNavigation />
            </div>
            <div className='center-area'>
              <PageRouter />
            </div>
            <div className='right-content'>
              <SideBar />
            </div>
          </div>
        </div>
      </ThemeProvider>
    </div>
  );
}

export default App;
